import { useEffect } from 'react';
import { isIOS } from '../utils/platform.utils';

/**
 * iOSのSafariで入力ボックスにフォーカスする時の自動スクロールを防ぐ
 * @param useLocalSession LIFFかどうか
 * @returns useEffect
 */
export const usePreventScrollOnFocus = (useLocalSession: boolean) => {
  return useEffect(() => {
    // iosでない、またはLIFFの場合、適用しない
    if (!isIOS() || useLocalSession) return;

    let onFocus = (e: FocusEvent) => {
      let target = e.target as HTMLElement;

      if (willOpenKeyboard(target)) {
        // Safariが要素をビューにスクロールしないために、
        // Transformで要素を移動して、Safariを要素が一番上にいると誤認させる
        target.style.transform = 'translateY(-2000px)';
        requestAnimationFrame(() => {
          // target.style.transform = '';
          // setTimeoutで要素の位置を元に戻す。setTimeoutがないと、うまくSafariを騙せないみたいです。（スクロールしてしまう）
          setTimeout(() => {
            target.style.transform = '';
          }, 0);

          if (visualViewport) {
            if (visualViewport.height < window.innerHeight) {
              // キーボードが表示されている場合、手動で要素を画面内にスクロールする
              requestAnimationFrame(() => {
                target.scrollIntoView();
              });
            } else {
              // キーボードが表示されていない場合、表示するまで待って（resizeイベントで）からスクロールする
              visualViewport.addEventListener(
                'resize',
                () => target.scrollIntoView(),
                { once: true }
              );
            }
          }
        });
      }
    };

    document.addEventListener('focus', onFocus, true);

    return () => {
      document.removeEventListener('focus', onFocus, true);
    };
  }, []);
};

const nonTextInputTypes = new Set([
  'checkbox',
  'radio',
  'range',
  'color',
  'file',
  'image',
  'button',
  'submit',
  'reset'
]);

const willOpenKeyboard = (target: Element) => {
  return (
    (target instanceof HTMLInputElement &&
      !nonTextInputTypes.has(target.type)) ||
    target instanceof HTMLTextAreaElement ||
    (target instanceof HTMLElement && target.isContentEditable)
  );
};
